export default __webpack_public_path__ + "static/media/182.ca90477d.png";